import HttpData from "@/http/data/http-data";

export interface IQrServerLogEntryApiData {
    id: number;
    building_id: string;
    type: string;
    code: string;
    message: string;
    created_at: string;
}

export default class QrServerLogEntryData extends HttpData {
    public id: number;
    public buildingId: string;
    public type: string;
    public code: string;
    public message: string;
    public createdAt: string;

    constructor(data: IQrServerLogEntryApiData) {
        super();

        this.id = data.id;
        this.buildingId = data.building_id;
        this.type = data.type;
        this.code = data.code;
        this.message = data.message;
        this.createdAt = data.created_at;
    }
}
